var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTravel = function SvgTravel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 23H16V22H8V23H6V22H5C3.895 22 3 21.105 3 20V7C3 5.895 3.895 5 5 5H8V3C8 2.448 8.448 2 9 2H15C15.552 2 16 2.448 16 3V5H19C20.105 5 21 5.895 21 7V20C21 21.105 20.105 22 19 22H18V23ZM10 9H8V18H10V9ZM16 9H14V18H16V9ZM14 4H10V5H14V4Z",
    fill: "currentColor"
  })));
};
export default SvgTravel;